import { Route, Routes } from "react-router-dom";
import CreateCar from "../../pages/car/create-car.page";
import UpdateCar from "../../pages/car/update-car.page";
import ListCars from "../../pages/car/list-cars.page";
import { ACCESS_RULES } from "../../shared/auth/access-control";
import RoleProtectedRoute from "../protected/role-protected-route.component";

const CarsRoutes = () => {
  return (
    <Routes>
      <Route path="/add" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.CARS}><CreateCar /></RoleProtectedRoute>} />
      <Route path="/:carId/edit" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.CARS}><UpdateCar /></RoleProtectedRoute>} />
      <Route path="/list" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.CARS}><ListCars /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default CarsRoutes;
